const PropTypes = require('prop-types');
const React = require('react');
const NumericInput = require('components/shared/numeric_input');

function PackageInput(props) {
  const numericInputFor = (fieldName, defaultValue) => {
    return (
      <NumericInput
        className="input-group__input align-right"
        required="required"
        placeholder="0.0"
        pattern="[0-9.]*"
        defaultValue={defaultValue}
        name={`shipping_label_form[package][${fieldName}]`}
      />
    );
  };

  const renderSubtitle = (subtitleKey) => {
    if (subtitleKey) {
      return (
        <span className="hint ml-half">
          {I18n.t(`js.dashboard.selling.shippingLabels.package.${subtitleKey}`)}
        </span>
      );
    }
    return null;
  };

  return (
    <div className="g-col-3 g-col-mobile-12">
      <label
        className="float control-label"
        htmlFor={`shipping_label_form_package_${props.fieldName}`}
      >
        {I18n.t(`js.dashboard.selling.shippingLabels.package.${props.titleKey}`)}
        {renderSubtitle(props.subtitleKey)}
      </label>

      <div className="input-group mb-1">
        {numericInputFor(props.fieldName, props.defaultValue)}
        <span className="input-group__text">
          {props.measurementUnitText}
        </span>
      </div>
    </div>
  );
}

PackageInput.propTypes = {
  fieldName: PropTypes.string.isRequired,
  titleKey: PropTypes.string.isRequired,
  subtitleKey: PropTypes.string,
  measurementUnitText: PropTypes.string.isRequired,
};

module.exports = PackageInput;



// WEBPACK FOOTER //
// ./javascripts/components/shipping_labels/package_input.jsx